import React from 'react';
import { StoryElement } from './story';
import { Story } from '../../../schema';

export const StoryBox = (props: {
  story: Story;
  index: number;
  deleteStory: (storyId: string) => void;
  onEdit: () => void;
}) => {
  const bgColor = props.index % 2 === 0 ? 'bg-canvas' : 'bg-surface';

  return (
    <div className={`${bgColor} py-12`}>
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <StoryElement story={props.story} onEdit={props.onEdit} deleteStory={props.deleteStory} />
      </div>
    </div>
  );
};
